import React from 'react';
import { Link } from 'react-router-dom';
import visionImg from '../../images/vision.webp'; // Replace with your actual image
import spimg1 from '../../images/ab-shape-1.png';
import spimg2 from '../../images/ab-shape-2.png';


const VisionMission = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className={`wpo-about-section ${props.vmClass}`}>
            <div className="container">
                <div className="row">
                    

                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-about-text">
                            
                            <div className="wpo-about-icon-content">
                                <h2>Our <span>Vision</span> &<span> Mission</span></h2>

                                <h5> Vision</h5>
                                <p>
                                    To be the premier provider of cutting-edge digital marketing, web development, and software solutions, recognized for our creativity, innovation, and customer-centric approach
                                </p>

                                <h5>Mission</h5>
                                <p>
                                    To deliver exceptional digital solutions that drive business growth and create lasting value for our clients.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-about-wrap">
                            <div className="wpo-about-img">
                                <img src={visionImg} alt="vision and mission" />
                                <div className="wpo-ab-shape-1"><img src={spimg1} alt="shape" /></div>
                                <div className="wpo-ab-shape-2"><img src={spimg2} alt="shape" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VisionMission;
